module.exports = __webpack_public_path__ + "img/arduino.6fa02da1.svg";